import React, {useMemo, useState} from "react";
import {Button, Col, Row, Tabs} from "antd";
import {compose} from "redux";
import {translate} from "react-i18next";
import UnionTableSelectAvailable from "./UnionTableSelectAvailable";
import UnionTableSelectResult from "./UnionTableSelectResult";
import {buildWholeSQL, QUERY_HEIGHT} from "./utils";
import {readDatasetBuilderWizardQueryDatasetPreviewRows} from "../../actions";
import {connect} from "react-redux";
import {MARGIN_MD, MODAL_WIDTH_XL, SPAN_TWO_THIRDS} from "../../../../../styles/constants";
import ZoomableHighlightedTextarea from "../../../../../components/zoomable-highlighted-textarea";
import ObjectPreview from "./ObjectPreview";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import UnionAlert from "./UnionAlert";


const AVAILABLE_TAB = 'AVAILABLE_TAB';
const SELECTED_TAB = 'SELECTED_TAB';

const mapStateToProps = state => ({
    rows: state.scenes.mappingHandler.datasetBuilder.index.rows,
    selectedTables: state.scenes.mappingHandler.datasetBuilder.unionModalProps.selectedTables,
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
    connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
});

const mapDispatchToProps = dispatch => ({
    fetchRows: ({connId, limit, page, query, searchText, filters, sortCol, sortByDesc, rows}) =>
        dispatch(readDatasetBuilderWizardQueryDatasetPreviewRows(connId, limit, page, query, searchText, getFilterObjFromViewerObj(rows && rows.columns, searchText, filters), sortCol, sortByDesc)),
});

const UnionTableSelect = ({t, rows, fetchRows, selectedTables, connId, connections}) => {
    const [currentTab, setCurrentTab] = useState(AVAILABLE_TAB)
    const [isRowsModalVisible, setIsRowsModalVisible] = useState(false);
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);
    const computedQuery = useMemo(() => buildWholeSQL(selectedTables, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null), [selectedTables, selectedConnection]);

    return (
        <div style={{position: "relative"}}>
            <Row>
                <Col span={SPAN_TWO_THIRDS}>
                    <UnionAlert/>
                </Col>
                <Col>
                    <Button
                        type="default"
                        onClick={() => setIsRowsModalVisible(true)}
                        style={{position: "absolute", top: 0, right: 0, zIndex: 999}}
                        disabled={!computedQuery || !connId}
                    >
                        {t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.unionPreview')}
                    </Button>
                </Col>
            </Row>
            <Tabs
                onTabClick={setCurrentTab}
                activeKey={currentTab}
            >
                <Tabs.TabPane
                    key={AVAILABLE_TAB}
                    tab={t('scenes.mappingHandler.DatasetBuilder.wizard.step.query.tabs.available.title')}
                >
                    <UnionTableSelectAvailable/>
                </Tabs.TabPane>
                <Tabs.TabPane
                    key={SELECTED_TAB}
                    tab={t('scenes.mappingHandler.DatasetBuilder.wizard.step.query.tabs.selected.title')}
                >
                    <UnionTableSelectResult/>
                </Tabs.TabPane>
            </Tabs>
            <div style={{fontFamily: 'monospace', marginTop: MARGIN_MD, height: QUERY_HEIGHT}}>
                <ZoomableHighlightedTextarea
                    disabled
                    value={computedQuery}
                    modalProps={{bodyStyle: {height: "75vh"}, width: MODAL_WIDTH_XL}}
                />
            </div>
            <ObjectPreview
                rows={rows}
                isRowsModalVisible={isRowsModalVisible}
                onRowsModalHide={() => {
                    setIsRowsModalVisible(false);
                }}
                fetchRows={fetchRows}
                connId={connId}
                query={computedQuery}
            />
        </div>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(UnionTableSelect);